/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Rejection_NoteInputs */

const en_directory_submit_review_rejection_note = /** @type {(inputs: Directory_Submit_Review_Rejection_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewer feedback`)
};

const zh_directory_submit_review_rejection_note = /** @type {(inputs: Directory_Submit_Review_Rejection_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核反馈`)
};

/**
* | output |
* | --- |
* | "Reviewer feedback" |
*
* @param {Directory_Submit_Review_Rejection_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_rejection_note = /** @type {((inputs?: Directory_Submit_Review_Rejection_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Rejection_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_rejection_note(inputs)
	return zh_directory_submit_review_rejection_note(inputs)
});
export { directory_submit_review_rejection_note as "directory.submit.review.rejection_note" }